import React from "react";

import { Box, Preloader, Stack } from "@origin-digital/ods-core";

export const Loading: React.FC = () => (
  <Box
    display="flex"
    justifyContent="flex-end"
    alignItems="flex-end"
    style={{ height: "420px" }}
  >
    <Stack alignX="center" space="xxxlarge" data-id="loading">
      <Preloader />
    </Stack>
  </Box>
);
